import { createContext } from 'react';

import { ProfileDto } from '@clh/api-client';

export interface CurrentProfileContextType {
    profile?: ProfileDto;
}

export default createContext<CurrentProfileContextType>(undefined as any);
